import { FC, useEffect, useState } from 'react'
import LinearProgressBar from './LinearProgressBar'
import DatePickerInput from './DatePickerInput'
import closeIcon from '../images/close-icon.svg'
import Deadline from '../deadline'
import { CommonGoalType } from './CommonGoal'
import SnackbarAlert from './SnackbarAlert'
import { Cookies } from 'react-cookie'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

interface Props {
    goalIdTarget: number;
    goalList: CommonGoalType[];
    handleClickClose: any;
}

const EditCommonGoalDueDateDialog: FC<Props> = ({
    goalIdTarget, goalList, handleClickClose
}) => {

    const [selectedDate, setSelectedDate] = useState<null | moment.Moment>(null)
    const [loading, setLoading] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState<null | {
        message: string,
        severity?: 'success' | 'info' | 'warning' | 'error',
        autoHideDuration?: number | null
    }>(null)

    const goalTarget = goalList?.find(goal => goal.id === goalIdTarget)
    const goalNameTarget = goalTarget?.goal

    const currentDeadline = new Deadline(new Date(goalTarget?.deadline || ''))

    const [newDeadline, setNewDeadline] = useState<Deadline | null>(null)

    useEffect(() => {
        if (selectedDate !== null) {
            setNewDeadline(new Deadline(selectedDate.toDate()))
        }
    }, [selectedDate])

    const cookie = new Cookies()

    const navigate = useNavigate()

    const handleClickEdit = () => {
        setLoading(true)
        setSnackbarMessage(null)
        axios.put(`/CommonGoals/${goalIdTarget}`, {
            deadline: selectedDate?.format('YYYY-MM-DD'),
            staffId: cookie.get('user')?.id
        }, {
            headers: {
                'Authorization': `Bearer ${cookie.get('user')?.token}`
            },
        }).then(() => {
            setSnackbarMessage({
                message: 'Edit Due Date Success',
                severity: 'success',
                autoHideDuration: 2000,
            })
            setTimeout(() => {
                setLoading(false)
                handleClickClose()
                navigate(0)
            }, 2000)
        }
        ).catch(() => {
            setLoading(false)
            setSnackbarMessage({
                message: 'Edit Due Date Failed',
                severity: 'error',
                autoHideDuration: 2000,
            })
        })
    }

    return (
        <div className='EditDueDateDialog'>
            <div className="EditDueDateDialog-dialog common-goal">
                <button className="ProgressDialog-close-button" onClick={handleClickClose}>
                    <img src={closeIcon} width={24} height={24} alt="close-icon" />
                </button>
                {
                    (loading) &&
                    <div className="ProgressDialog-linear-progress">
                        <LinearProgressBar />
                    </div>
                }
                <div className="AddStudentDialog-header-container">
                    <h4 className='AddStudentDialog-title'>Edit Due Date</h4>
                    <h4 className='AddStudentDialog-goal-name'>{goalNameTarget}</h4>
                </div>
                <div className='EditDueDateDialog-deadline'>
                    <DatePickerInput
                        label='New Due Date'
                        emptyLabel='Select Date'
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        disabled={loading}
                        inputVariant="outlined"
                        required
                        style={
                            {
                                padding: '15px 14px',
                            }
                        }
                    />
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Current Due Date</th>
                            <th></th>
                            <th scope="col">New Due Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{currentDeadline.deadline}</td>
                            <td style={{ whiteSpace: 'pre', textAlign: 'center' }}>
                                {newDeadline &&
                                    <div className='flex-center gap1'>
                                        <p>❯</p>
                                        <p>{newDeadline?.compareDeadlineDate(currentDeadline)}</p>
                                        <p>❯</p>
                                    </div>
                                }
                            </td>
                            <td>{newDeadline?.deadline}</td>
                        </tr>
                    </tbody>
                </table>
                <div className="ProgressDialog-bottom-container" >
                    <div className="ProgressDialog-actions" style={{ marginLeft: 'auto' }}>
                        <button className="ProgressDialog-button" onClick={handleClickClose}>Cancel</button>
                        <button className="ProgressDialog-button" onClick={handleClickEdit} disabled={selectedDate === null || loading || newDeadline?.compareDeadlineDate(currentDeadline) === "ไม่มีการเปลี่ยนแปลง"}>Edit</button>
                    </div>
                </div>
            </div>
            {
                (snackbarMessage) &&
                <SnackbarAlert severity={snackbarMessage.severity} message={snackbarMessage.message} />
            }
        </div>
    )
}

export default EditCommonGoalDueDateDialog